<template>
  <div class="job-sync-detail-container" v-rect-loading="loading">
    <NoBorderTable
      class="table"
      :noOperation="true"
      :noHeader="true"
      :tableColumns="tableColumns"
      :listData="displayList"
      :rowClassName="tableRowClassName"
    >
      <template #jobName="{ row }">
          <span class="job-name" @click="handleClickJobName(row)">
            {{ row.i18nTitle }}
          </span>
        </template>
    </NoBorderTable>
    <el-pagination
      class="pagination"
      background
      layout="total, sizes, prev, pager, next"
      :total="pageInfo.total"
      :page-count="pageInfo.page"
      :page-size="pageInfo.pageSize"
      @current-change='handlePageChange'
      @size-change='handleSizeChange'
      >
    </el-pagination>
  </div>
</template>

<script>
import NoBorderTable from '@/components/tableList/noBorderTable.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    NoBorderTable
  },
  props: {
    historyId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.apScheduler',
      loading: false,
      dataList: [],
      displayList: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.dialog.jobId`),
          dataKey: 'id'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.jobName`),
          dataKey: 'i18nTitle',
          slotName: 'jobName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.companyName`),
          dataKey: 'companyI18nName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.atsJobId`),
          dataKey: 'ats_job_id'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.createTime`),
          dataKey: 'created_time'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.updateTime`),
          dataKey: 'updated_time'
        },
        {
          label: this.$t(`${this.i18nPrefix}.dialog.option`),
          dataKey: 'option',
          formatter: (data, row) => {
            if (!row.is_deleted) {
              return this.$t(`${this.i18nPrefix}.recordStatus.${data}`)
            }
            return ''
          }
        }
      ]
      return columns
    }
  },
  async created () {
    this.initDataList()
  },
  methods: {
    ...mapActions('apScheduler', ['getJobSyncDetailInfoByHistoryId']),
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    async initDataList () {
      this.loading = true
      try {
        const resp = await this.getJobSyncDetailInfoByHistoryId(this.historyId)
        if (resp) {
          const dataList = resp
          _.forEach(dataList, (job) => {
            addI18nProperty(job, 'i18nTitle', 'cn_title', 'title')
            addI18nProperty(job, 'companyI18nName', 'company_cn_name', 'company_name')
          })
          this.dataList = dataList
          this.handlePageChange(1)
        }
      } finally {
        this.loading = false
      }
    },
    async handlePageChange (val) {
      this.loading = true
      const dataList = this.dataList
      try {
        this.pageInfo.page = val
        const startIndex = (this.pageInfo.page - 1) * this.pageInfo.pageSize
        if (dataList) {
          this.pageInfo.total = dataList.length
          this.displayList = dataList.slice(startIndex, startIndex + this.pageInfo.pageSize)
        }
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 200)
      }
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.handlePageChange(1)
    },
    handleClickJobName (row) {
      const path = `${location.origin}/job-detail-new/${row.id}/c/`
      window.open(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-sync-detail-container {

  .job-name {
    cursor: pointer;
  }

  ::v-deep .el-table {
    border: 0px;

    .el-table__header {
      .el-table__cell {
        font-size: 14px;
        padding: 20px 0;
        color: #000000;
        font-weight: 600;

        &.is-leaf {
          background-color: #FFFFFF;
        }
      }
    }

    .el-table__body {
        .el-table__cell {
          padding: 20px 0;

          .cell {
            padding: 0 5px;
          }
        }

        .gray-background {
          background: #f7f7f7;
        }
    }
  }

  .pagination {
    text-align: right;
    margin-right: 10px;
    padding: 10px;
  }
}
</style>
